import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../../common/Button"
import Card from "../../../../common/Card"
import PannelBody from "../../../../fragments/PannelBody"
import PannelHeader from "../../../../fragments/PannelHeader"
import Subtitle from "../../../../fragments/Subtitle"
import AppointmentHistoryItem from "./AppointmentHistoryItem"
import { detailsActions } from "../../../../../store/details"
import { useUserTabEditPermissionDisabled } from "../../../../../lib/usersPermissions"


const AppointmentHistory = () => {
    let userPermissionDisabled = useUserTabEditPermissionDisabled('appointments_view')

    const [appointments, setAppointments] = useState(null)
    const activeCase = useSelector(state => state.case.activeCase) 

    const dispatch = useDispatch()

    const openTabHandler = () => {
        dispatch(detailsActions.setActiveTab(15))
    }

    useEffect(() => {
        if (activeCase && activeCase.appointments && activeCase.appointments.length>0) {   

            const sorted = [...activeCase.appointments].sort((a, b) => new Date(a.date) - new Date(b.date));            
            const slicedArray = sorted.slice(0, 4);
            setAppointments(slicedArray)
        }
    }, [activeCase])


    return <>
        {userPermissionDisabled && <>
            {activeCase && <Card>
                <PannelHeader>
                    <div className="flex-vertical-center">
                        <div>
                            <h2>Future Appointments</h2>
                            <Subtitle>
                                {appointments && <>Future {appointments.length} appointments</>}
                            </Subtitle>
                        </div>
                        <Button btnStyle='btn_simple' click={openTabHandler} bypassisCaseArchived={true}>View All <i className="ti ti-arrow-up-right"></i></Button>
                    </div>
                    
                </PannelHeader>
                <PannelBody>
                    {appointments && appointments.map(item => (
                        <AppointmentHistoryItem key={item.id} data={item} />
                    ))}
                    {!appointments && <p>No future appointments were found in NG.</p>}
                </PannelBody>
            </Card>}
        </>}
    </>
}

export default AppointmentHistory